import idx from 'idx';
import React from 'react';
import wait from 'utils/wait';
import openPopup from 'utils/openPopup';
import { graphql, compose, DataValue } from 'react-apollo';
import ToastActions from 'actions/ToastActions';
import { settingsForProvider } from 'components/lib/AccountLinkingWindowSettings';
import INFINITY_SOURCES_QUERY from 'settings/queries/linkedAccountsSettingsContainer.gql';
import UNLINK_MUTATION from 'settings/queries/linkedAccountsSettingsContainerUnlinkAccount.gql';
import { LinkedAccountsSettingsContainer as LinkedAccountsSettingsContainerType } from 'settings/queries/__generated__/LinkedAccountsSettingsContainer';

type Props = {
  unlink: Function;
  children: any;
  data: DataValue<LinkedAccountsSettingsContainerType>;
};

class LinkedAccountsSettingsContainer extends React.Component<Props, {}> {
  constructor(props: Props) {
    super(props);

    this.link = this.link.bind(this);
    this.unlink = this.unlink.bind(this);
  }

  getContentSources = () => {
    return this.props.data.me?.composer?.contentSourcesInfinity ?? [];
  };

  async unlink(source: any) {
    const res = await this.props.unlink({ variables: { provider: source.providerKey } });
    const err = idx(res, _ => _.data.unlinkAccount.error.message);

    if (err) {
      ToastActions.showErrorToast(`Could not unlink: ${err}`);
    } else {
      this.props.data.refetch();
    }
  }

  link(source: any) {
    if (!source.linkedAccountInfo || !source.linkedAccountInfo.authUrl) {
      console.debug(source);
      console.error('cannot link unlinkable account');
      return;
    }

    const popup = openPopup(
      `${source.linkedAccountInfo.authUrl}`,
      `Link with ${source.title}`,
      settingsForProvider(source.providerKey)
    );

    wait(() => popup?.closed).then(
      () => this.props.data.refetch(),
      e => {
        console.debug(e, e && e.stack);
        console.error('Error while waiting for account linking popup to close');
        // Reload content sources anyway - hope for the best
        this.props.data.refetch();
      }
    );
  }

  render() {
    if (!this.props.children) {
      return null;
    }

    return this.props.children({
      link: this.link,
      unlink: this.unlink,
      loading: this.props.data.loading,
      sources: this.getContentSources(),
    });
  }
}

const composer = compose(
  graphql(INFINITY_SOURCES_QUERY),
  graphql(UNLINK_MUTATION, { name: 'unlink' })
);

export { LinkedAccountsSettingsContainer };
export default composer(LinkedAccountsSettingsContainer);
